import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'

const economicActivityChange = () => {
  const { embassiesEconomicActivity, OrganizationsEconomicActivity } = lookups
  const formStore = useFormStore()
  formStore.extraMap.isNocRequest = [
    embassiesEconomicActivity,
    OrganizationsEconomicActivity
  ].includes(+formStore.form.values.economicActivityId)
}

const establishmentPartnershipTypeIdChange = () => {
  const {
    partnershipBetweenTwoCompaniesAndTheirBranches,
    branchOfTheEmirateOfAbuDhabi,
    branchOfAnotherEmirate,
    gulfBranch,
    foreignBranch,
    publicAndPrivateShareholdingCompaniesAndTheirSubsidiaries,
    freeZonesBranch
  } = lookups.establishmentPartnershipType
  const formStore = useFormStore()
  if (!formStore.form.values.establishmentPartnershipTypeId) {
    formStore.extraMap = {
      ...formStore.extraMap,

      isConcernedEstablishmentAvailable: false,
      isEstablishmentCanBeGroup: false,
      isConcernedEstablishmentRequired: false,
      isConcernedPersonAvailable: true,
      isPersonCanBeGroup: true,
      isConcernedPersonRequired: false
    }

    if (formStore.extraMap.administrativeRegionId != 1) {
      formStore.extraMap.isConcernedPersonAvailable = true
      formStore.extraMap.isConcernedPersonRequired = true
    }

    return
  }
  switch (formStore.form.values.establishmentPartnershipTypeId) {
    case partnershipBetweenTwoCompaniesAndTheirBranches:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: true,
        isEstablishmentCanBeGroup: true,
        isConcernedEstablishmentRequired: true,
        isConcernedPersonAvailable: false,
        isPersonCanBeGroup: false,
        isConcernedPersonRequired: false
      }
      break
    case branchOfTheEmirateOfAbuDhabi:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: true,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: false,
        isConcernedPersonAvailable: true,
        isPersonCanBeGroup: true,
        isConcernedPersonRequired: true
      }
      break
    case branchOfAnotherEmirate:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: true,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: true,
        isConcernedPersonAvailable: false,
        isPersonCanBeGroup: false,
        isConcernedPersonRequired: false
      }
      break
    case gulfBranch:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: true,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: false,
        isConcernedPersonAvailable: true,
        isPersonCanBeGroup: true,
        isConcernedPersonRequired: true
      }
      break
    case foreignBranch:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: false,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: false,
        isConcernedPersonAvailable: false,
        isPersonCanBeGroup: false,
        isConcernedPersonRequired: false
      }
      break
    case freeZonesBranch:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: true,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: true,
        isConcernedPersonAvailable: true,
        isPersonCanBeGroup: true,
        isConcernedPersonRequired: true
      }
      break

    case publicAndPrivateShareholdingCompaniesAndTheirSubsidiaries:
      formStore.extraMap = {
        ...formStore.extraMap,

        isConcernedEstablishmentAvailable: false,
        isEstablishmentCanBeGroup: false,
        isConcernedEstablishmentRequired: false,
        isConcernedPersonAvailable: true,
        isPersonCanBeGroup: true,
        isConcernedPersonRequired: true
      }
      break

    default:
      break
  }
}

const establishmentAgentTypeChange = () => {
  const formStore = useFormStore()

  if (formStore.form.values.establishmentAgentTypeId == 1) {
    formStore.extraMap = {
      ...formStore.extraMap,

      isConcernedEstablishmentAvailable: true,
      isEstablishmentCanBeGroup: false,
      isConcernedEstablishmentRequired: true,
      isConcernedPersonAvailable: false,
      isPersonCanBeGroup: false,
      isConcernedPersonRequired: false
    }
  } else {
    formStore.extraMap = {
      ...formStore.extraMap,

      isConcernedEstablishmentAvailable: true,
      isEstablishmentCanBeGroup: false,
      isConcernedEstablishmentRequired: false,
      isConcernedPersonAvailable: true,
      isPersonCanBeGroup: false,
      isConcernedPersonRequired: true
    }
  }
}

const establishmentTypeChange = () => {
  const formStore = useFormStore()
  const { establishmentRequestActionTypeId = '' } = formStore.form.values
  if (establishmentRequestActionTypeId == 1) {
    formStore.form.setFieldValue('establishmentRequestTypeId', 1)
  } else {
    formStore.form.setFieldValue('establishmentRequestTypeId', null)
  }
}

const filterApplicationType = (options) => {
  const formStore = useFormStore()
  const { establishmentRequestActionTypeId = '' } = formStore.form.values
  if (establishmentRequestActionTypeId == 2) {
    return options.filter((item) => ![1, 8, 9].includes(item.id))
  }
  return options
}
export default function () {
  return {
    economicActivityChange,
    establishmentPartnershipTypeIdChange,
    establishmentAgentTypeChange,
    establishmentTypeChange,
    filterApplicationType
  }
}
